import { computed, inject, Injectable, Signal } from '@angular/core';
import { FormQuestionState, FormSectionState } from '@pixacare/forms';
import { FormBridge } from '@pixacare/forms-angular';
import { FormGridInstanceStore } from './form-grid-instance.store';
import { mergeVisibleQuestions, mergeVisibleSections } from './form-grid-bridge-merge.utils';

@Injectable()
export class FormGridVisibilityService {
  private readonly store = inject(FormGridInstanceStore);
  private readonly sectionsByFormType = new Map<string, Signal<FormSectionState[]>>();
  private readonly questionsByKey = new Map<string, Signal<FormQuestionState[]>>();

  reset(): void {
    this.sectionsByFormType.clear();
    this.questionsByKey.clear();
  }

  visibleSections(formType: string): Signal<FormSectionState[]> {
    let sig = this.sectionsByFormType.get(formType);
    if (!sig) {
      sig = computed(() => mergeVisibleSections(this.bridgesForFormType(formType)));
      this.sectionsByFormType.set(formType, sig);
    }
    return sig;
  }

  visibleQuestions(formType: string, sectionId: string): Signal<FormQuestionState[]> {
    const key = `${formType}|${sectionId}`;
    let sig = this.questionsByKey.get(key);
    if (!sig) {
      sig = computed(() => mergeVisibleQuestions(this.bridgesForFormType(formType), sectionId));
      this.questionsByKey.set(key, sig);
    }
    return sig;
  }

  private bridgesForFormType(formType: string): FormBridge[] {
    const result: FormBridge[] = [];
    for (const entity of this.store.entities()) {
      const bridge = this.store.bridge(entity.entityKey, formType);
      if (bridge) {
        result.push(bridge);
      }
    }
    return result;
  }
}
